module.exports = __webpack_public_path__ + "media/assets/images/landings/hexagon_15deg-421f07619606cd768a635c8d636250e4.svg";